import {ActionTypeStrategy, TransactionListCta} from '@dcp/configurator';
import {DcpSupportFormService} from '../support-form/dcp-support-form.service';

export class SupportFormActionTypeStrategy implements ActionTypeStrategy {

  constructor(
    private dcpSupportFormService: DcpSupportFormService,
    private cta: TransactionListCta
  ) {
  }

  public action(): void {
    if (this.cta?.targetUrl) {
      this.dcpSupportFormService.open(undefined, undefined, this.cta.targetUrl);
    } else {
      this.dcpSupportFormService.open();
    }
  }
}
